import { gql } from '@apollo/client';

export default gql`
  mutation bulkLicenseAction($data: [BulkLicenseActionInput!]!) {
    bulkLicenseAction(data: $data) {
      request {
        userId
      }
      licenses {
        id
      }
      error
    }
  }
`;
